import moment from "moment";
import getMomentDateObj from "./getMomentDateObj";
import getMomentTomorrow from "./getMomentTomorrow";
import setMomentDateObjZero from "./setMomentDateObjZero";
import getMomentNow from "./getMomentNow";

const filterPerformancesDateFilter = (performances, filter, today, timezone, dayFilters, locale, overviewFilterIgnoreOnPerformances) => {
    let filteredPerformances
    const nowMoment = getMomentNow(timezone)
    
    if(filter.time && !overviewFilterIgnoreOnPerformances) {
        
        const weekDayFilters = dayFilters ? Array.isArray(filter.time) ? _.intersection(_.keys(dayFilters.filterWeekDays), filter.time) : _.intersection(_.keys(dayFilters.filterWeekDays), [filter.time]) : []
        const hasEndDate = Array.isArray(filter.time) ? _.find(filter.time, val => {
            return val.search("end") !== -1
        }):  _.find([filter.time], val => {
            return val.search("end") !== -1
        })
        const hasStartDate = Array.isArray(filter.time) ? _.find(filter.time, val => {
            return val.search("start") !== -1
        }) :  _.find([filter.time], val => {
            return val.search("start") !== -1
        })
        const startDate = hasStartDate ? moment(parseInt(hasStartDate.split(':')[1])) : false
        const endDate = hasEndDate ? moment(parseInt(hasEndDate.split(':')[1])) : false
        if(filter.time === 'today') {            
            filteredPerformances = performances.filter(performance => {
                const performanceDate = setMomentDateObjZero(getMomentDateObj(performance.timeUtc, timezone))
                return performanceDate.isSame(today) && nowMoment.isSameOrBefore(getMomentDateObj(performance.timeUtc, timezone))
            })
        } else if(filter.time === 'tomorrow') {
            const tomorrow = getMomentTomorrow(today)
            
            filteredPerformances = performances.filter(performance => {
                const performanceDate = setMomentDateObjZero(getMomentDateObj(performance.timeUtc, timezone))
                return performanceDate.isSame(tomorrow)
            })
        } else if(filter.time === 'week') {
            const lastDay = today.clone().add(7, 'days')
            
            filteredPerformances = performances.filter(performance => {
                const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
                return today.isBefore(performanceDate) && performanceDate.isBefore(lastDay) && nowMoment.isSameOrBefore(performanceDate)
            })
        }

        if(weekDayFilters.length !== 0) {
            filteredPerformances = performances.filter(performance => {
                const weekArrayLong = moment.localeData(locale).weekdays(true)

                const momentPerfDate = getMomentDateObj(performance.timeUtc, timezone)
                const momentPerfDateZero = setMomentDateObjZero(momentPerfDate.clone())
                const momentPerfWeekDayNumber = momentPerfDateZero.weekday()
                const momentPerfWeekDay = weekArrayLong[momentPerfWeekDayNumber].toLowerCase()

                return _.contains(weekDayFilters, momentPerfWeekDay)
            })
        }
        if(startDate || endDate) {
            filteredPerformances = performances.filter(performance => {
                const momentPerfDate = getMomentDateObj(performance.timeUtc, timezone)
                const momentPerfDateZero = setMomentDateObjZero(momentPerfDate.clone())
                if(startDate && endDate) {
                    return momentPerfDateZero.isSameOrBefore(endDate) && momentPerfDateZero.isSameOrAfter(startDate)
                } else if(startDate && !endDate) {
                    return momentPerfDateZero.isSame(startDate)
                }   
            })
        }
    }

    if(filteredPerformances) {
        return filteredPerformances
    } else {
        return performances
    }
}

export default filterPerformancesDateFilter